import { useTranslation } from "react-i18next";
import "./ImpactTileSkeleton.css";

interface ImpactTileSkeletonProps {
  count?: number;
}

const ImpactTileSkeleton = ({ count = 3 }: ImpactTileSkeletonProps) => {
  const { t } = useTranslation("common");
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="skeleton-impact-tile" role="status" aria-label={t("states.loading")}>
          {/* Label placeholder */}
          <div className="skeleton-impact-tile__label">
            <div className="skeleton-shimmer" />
          </div>

          {/* Value placeholder */}
          <div className="skeleton-impact-tile__value">
            <div className="skeleton-shimmer" />
          </div>

          {/* Meta placeholder */}
          <div className="skeleton-impact-tile__meta">
            <div className="skeleton-shimmer" />
          </div>
        </div>
      ))}
    </>
  );
};

export default ImpactTileSkeleton;
